<script>
  import UserUtil from '@/util/UserUtil'

  export default {
    data () {
      return {
        collapsed: false
      }
    },
    computed: {
      userInfo () {
        return this.$store.state.userInfo ? this.$store.state.userInfo : {}
      },
      defaultSelectedKeys () {
        let defaultSelectedKeys = []
        let menu = this.userInfo.menu || []
        menu.forEach((menu) => {
          if (menu.path === null) {
            menu.children.forEach((child) => {
              if (child.path === this.$route.path) {
                defaultSelectedKeys.push(child.path)
              }
            })
          } else if (menu.path === this.$route.path) {
            defaultSelectedKeys.push(menu.path)
          }
        })
        return defaultSelectedKeys
      }
    },
    methods: {
      logout: function () {
        let respuesta = () => {
          this.$router.push({
            name: 'Login'
          })
        }
        UserUtil.logout(respuesta, respuesta)
      },
      navigate (menu) {
        this.$router.push({path: menu.path})
        /* Tamaño tomado de: https://ant.design/components/grid/#Col */
        if (jQuery(window).width() < 992) {
          this.collapsed = true
        }
      }
    }
  }
</script>
<template src="./main.html"></template>
<style>
    .logo {
        /* background: rgba(255, 255, 255, .2); */
        float: left;
    }

    .ant-layout-header {
        padding: 0 10px;
        /*margin-bottom: 10px;*/
        /*background-color: #1d83b3;*/
    }

    .ant-layout-sider-zero-width-trigger {
        top: 0;
    }

    .menuColor{
        color: white;
    }

    .logoBg{
        background: #093637 !important;  /* fallback for old browsers */
    }

    .headerBg{
        /*background: #00b09b;  /* fallback for old browsers */
        /*background: -webkit-linear-gradient(to left, #96c93d, #00b09b);  /* Chrome 10-25, Safari 5.1-6 */
        /*background: linear-gradient(to left, #96c93d, #00b09b); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background: #44A08D !important;  /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #093637, #44A08D) !important;  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #093637, #44A08D) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }
</style>



// WEBPACK FOOTER //
// src/components/main/main.vue